import { render, staticRenderFns } from "./ClosedIresDeviceAssignmentDetails.vue?vue&type=template&id=62df3b28&scoped=true&"
import script from "./ClosedIresDeviceAssignmentDetails.vue?vue&type=script&lang=ts&"
export * from "./ClosedIresDeviceAssignmentDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClosedIresDeviceAssignmentDetails.vue?vue&type=style&index=0&id=62df3b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62df3b28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VDivider,VRow,VTextField})
